import styled from "styled-components";
import colors from "../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: right;
  width: 1600px;
  height: 100%;
  margin-top: 61px;
  margin-bottom: 57px;
  box-sizing: border-box;
  background: transparent;
  @media (max-width: 1400px) {
    width: 1100px;
    margin-top: 30px;
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 156px;
  height: 36px;
  border-radius: 4px;
  box-sizing: border-box;
  color: ${colors.white1};
  background: blue;
`;
